(function() {

	if( $( '.js-awards-wrapper' ).length > 0 ) {

		$( '.js-awards-wrapper' ).slick({
			slidesToShow : 3,
			slidesToScroll : 1,
			centerMode : false,
			arrows : true,
			infinite : false,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						arrows : true,
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows : false,
						dots : true,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			],
			prevArrow : `
				<button type="button" class="slick-prev article-arrow" aria-label="previous slide">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 31.481" class="w-6 h-6">
						<path d="M15.747,5.426l11.9,11.913a2.24,2.24,0,0,0,3.177,0,2.269,2.269,0,0,0,0-3.187L17.34.655a2.246,2.246,0,0,0-3.1-.066L.656,14.143A2.25,2.25,0,0,0,3.834,17.33Z" transform="translate(0 31.481) rotate(-90)" fill="#72818e"/>
					</svg>
				</button>
			`,
			nextArrow : `
				<button type="button" class="slick-next article-arrow" aria-label="next slide">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 31.481" class="w-6 h-6">
						<path d="M15.747,5.426l11.9,11.913a2.24,2.24,0,0,0,3.177,0,2.269,2.269,0,0,0,0-3.187L17.34.655a2.246,2.246,0,0,0-3.1-.066L.656,14.143A2.25,2.25,0,0,0,3.834,17.33Z" transform="translate(18) rotate(90)" fill="#72818e"/>
					</svg>
				</button>
			`
		});

	}

	if( $( '.js-press-wrapper' ).length > 0 ) {

		$( '.js-press-wrapper' ).slick({
			slidesToShow : 4,
			slidesToScroll : 1,
			centerMode : false,
			arrows : true,
			infinite : false,
			responsive: [
				{
					breakpoint: 1223,
					settings: {
						arrows : true,
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows : true,
						dots : false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			],
			prevArrow : `
			<button type="button" class="slick-prev article-arrow" aria-label="previous slide">
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 14.286 25">
			<g id="Polygon_3" data-name="Polygon 3" transform="translate(0 25) rotate(-90)" fill="#fff">
				<path d="M 23.89811706542969 13.78571701049805 L 1.101883411407471 13.78571701049805 L 12.5 0.7592929601669312 L 23.89811706542969 13.78571701049805 Z" stroke="none"/>
				<path d="M 12.5 1.518589019775391 L 2.203767776489258 13.28571701049805 L 22.79623413085938 13.28571701049805 L 12.5 1.518589019775391 M 12.5 -2.86102294921875e-06 L 25 14.28571701049805 L 0 14.28571701049805 L 12.5 -2.86102294921875e-06 Z" stroke="none" fill="#000"/>
			</g>
			</svg>
			</button>
			`,
			nextArrow : `
			<button type="button" class="slick-next article-arrow" aria-label="next slide">
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 14.286 25">
			<g id="Polygon_4" data-name="Polygon 4" transform="translate(14.286) rotate(90)" fill="#fff">
				<path d="M 23.89811706542969 13.78571701049805 L 1.101883411407471 13.78571701049805 L 12.5 0.7592929601669312 L 23.89811706542969 13.78571701049805 Z" stroke="none"/>
				<path d="M 12.5 1.518589019775391 L 2.203767776489258 13.28571701049805 L 22.79623413085938 13.28571701049805 L 12.5 1.518589019775391 M 12.5 -2.86102294921875e-06 L 25 14.28571701049805 L 0 14.28571701049805 L 12.5 -2.86102294921875e-06 Z" stroke="none" fill="#000"/>
			</g>
			</svg>
			</button>
			`
		});

	}

	$( '.js-reviews-carousel' ).slick({
		slidesToShow: 1,
		arrows : false,
		autoplay : true,
		autoplaySpeed : 5000
	});


})();

